import { ApolloError } from '@apollo/client';
import { path } from 'ramda';

export const getReadableErrorMessage = (error: any): string => {
  let result = typeof error === 'object' ? error?.message : error;
  if (error instanceof ApolloError) {
    const graphQLErrors = error.graphQLErrors.reduce((acc, err) => {
      const body: string | null | undefined = path(['extensions', 'exception', 'body', 'detail'], err);
      if (body) {
        acc.push(body);
      }
      return acc;
    }, [] as string[]);

    if (graphQLErrors.length) {
      result = graphQLErrors.join('\n');
    }
  }
  return result;
};
